import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskLines, Eyebrow, Reveal } from "./Motion";

export const PageHero = ({ eyebrow, title, intro, image, imageAlt = "", children }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "18%"]);
  return (
    <section ref={ref} className="relative bg-[#F9F8F3] pt-32 md:pt-40" data-testid="page-hero">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <div className="grid gap-10 lg:grid-cols-12 lg:items-end">
          <div className="lg:col-span-8">
            <Eyebrow>{eyebrow}</Eyebrow>
            <h1 className="font-display mt-6 text-4xl sm:text-5xl lg:text-7xl font-medium leading-[1] tracking-tight text-[#082619]">
              <MaskLines lines={title} />
            </h1>
          </div>
          <Reveal className="lg:col-span-4" delay={0.4}>
            <p className="text-base md:text-lg leading-relaxed text-[#4C6053]">{intro}</p>
            {children}
          </Reveal>
        </div>
      </div>
      {image && (
        <motion.div
          initial={{ clipPath: "inset(12% 8% 0% 8% round 24px)" }}
          animate={{ clipPath: "inset(0% 0% 0% 0% round 0px)" }}
          transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1], delay: 0.3 }}
          className="relative mt-14 h-[44vh] min-h-[280px] overflow-hidden md:mt-20 md:h-[62vh]"
        >
          <motion.img src={image} alt={imageAlt} style={{ y }} className="absolute inset-0 h-[120%] w-full object-cover -top-[10%]" fetchpriority="high" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#082619]/40 to-transparent" />
        </motion.div>
      )}
    </section>
  );
};
